module.exports = __webpack_public_path__ + "static/media/auto-login.dec25a25.svg";